class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  get selectors() {
    return {
      slider: "base-slider"
    }
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            this.initSlider();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 300px 0px"
    }).observe(this);
  }

  initSlider() {
    this.slider = this.querySelector(this.selectors.slider);

    if (!this.slider) {
      return;
    }

    this.slider.updateSlider();
  }
}

if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}
